import { storageRef } from '../../../config/firebase'
import uploadFiles from '../../../utils/storage/uploadFiles'
import { seoOgStorageChildPath, toPersistableMediaObject } from './persistableMediaObject'

/**
 * Upload a pending local media object to Storage.
 * Returns a persistable media object (no File / base64 / needUpload).
 *
 * @param {{ docId: string, localMedia: object, storagePath: string }} params
 */
export async function uploadSeoOgImage({ docId, localMedia, storagePath }) {
  if (!localMedia?.needUpload || !localMedia?.file) {
    return toPersistableMediaObject(localMedia)
  }

  const storageFolder = `${storagePath}/${docId}`
  const [uploaded] = await uploadFiles({
    files: [localMedia],
    storagePath: storageFolder,
  })

  return toPersistableMediaObject({
    ...localMedia,
    publicUrl: uploaded.publicUrl,
    needUpload: false,
    storagePath,
    isAvatar: true,
    isLayout: false,
  })
}

export async function deleteSeoOgStorageFile({ docId, media, storagePath }) {
  const path = seoOgStorageChildPath(docId, media, storagePath)
  if (!path) return
  try {
    await storageRef.child(path).delete()
  } catch (error) {
    // File may already be gone; do not fail the caller hard.
    console.log('deleteSeoOgStorageFile', path, error)
  }
}

/**
 * Resolve next persistable ogImage for save, uploading when needed.
 * Returns { nextOgImage, uploadedOrphan, previousToDelete }.
 */
export async function resolveOgImageForSave({ docId, localOgImage, previousOgImage, storagePath }) {
  if (!localOgImage) {
    return { nextOgImage: null, uploadedOrphan: null, previousToDelete: previousOgImage || null }
  }

  if (localOgImage.needUpload) {
    const nextOgImage = await uploadSeoOgImage({ docId, localMedia: localOgImage, storagePath })
    const previousToDelete =
      previousOgImage &&
      previousOgImage.fileName &&
      (previousOgImage.fileName !== nextOgImage.fileName || previousOgImage.fileExt !== nextOgImage.fileExt)
        ? previousOgImage
        : null
    return { nextOgImage, uploadedOrphan: nextOgImage, previousToDelete }
  }

  return {
    nextOgImage: toPersistableMediaObject(localOgImage),
    uploadedOrphan: null,
    previousToDelete: null,
  }
}
